export default [
  {
    sublabel: "Employer",
    label_name: "Employer",
    summary: `A person or organization that has: a place of business in the U.S.,
		  a valid Federal Employer Identification Number (FEIN) and the ability
		  to hire an employee in full-time employment.`,
    disabled: false,
    uri: "/dashboard/profiles/employer",
  },
  {
    sublabel: "Agent/Attorney",
    label_name: "Agent/Attorney",
    summary:
      "A legal entity or person who is authorized to act on behalf of an employer.",
    disabled: false,
    uri: "/dashboard/profiles/agent-attorney",
  },
  {
    sublabel: "Foreign Labor Recruiters",
    label_name: "Foreign Labor Recruiters",
    summary: "A legal entity or person who recruits H-2B workers.",
    disabled: false,
    uri: "/dashboard/profiles/foreign-labor",
  },
  {
    sublabel: "Crops or Commodities",
    label_name: "Crops or Commodities",
    summary:
      "A crop or commodity to be cultivated on behalf of an H-2A employer.",
    disabled: false,
    uri: "/dashboard/profiles/crop-commodity",
  },
  {
    sublabel: "Agriculture",
    label_name: "Agricultural Businesses",
    summary: "An agricultural business.",
    disabled: false,
    uri: "/dashboard/profiles/agriculture",
    // hidden: true,
  },
  {
    sublabel: "Worker Housing",
    label_name: "Worker Housing",
    summary: "Add Additional Housing Information",
    disabled: false,
    uri: "/dashboard/profiles/worker-housing",
  },
  {
    sublabel: "Material Terms of Employment",
    label_name: "Material Terms of Employment",
    summary: "Add Additional Material Terms of Employment",
    disabled: false,
    uri: "/dashboard/profiles/material-terms-of-employment",
  },
  {
    sublabel: "Foreign Worker",
    label_name: "Foreign Worker",
    summary:
      "A person who is being sponsored by an employer for permanent employment in the US",
    disabled: false,
    uri: "/dashboard/profiles/foreign-worker",
  },
];
